export default "__VITE_ASSET__Eyrfo159__"